export default "__VITE_ASSET__C8OZ6NDz__"